import React, { useEffect, useRef, useState } from "react";
import { fetchHomelocalexpertList } from "../services/Localocalexpertlist";
import { API_BASE } from "../api/apiConfig";

const Localocalexpertlist = () => {
  const [experts, setExperts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    loadExperts();
  }, []);

  const loadExperts = async () => {
    const res = await fetchHomelocalexpertList();
    if (res?.status) setExperts(res.data);
  };

  const scroll = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "left" ? -320 : 320,
      behavior: "smooth",
    });
  };

  return (
  <section className="py-20 md:py-16 lg:py-20 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6 mb-5 md:mb-8">
        <div className="">
          <p className="text-primary font-medium text-xs md:text-sm uppercase tracking-wider mb-1 md:mb-2">
          The People Behind The Trips
        </p>
        <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-slate-900">
          Meet Our Experts
        </h2>
        </div>
      
      </div>


      {/* Desktop */}
      <div className=" pb-4 md:pb-6 -mb-4 md:-mb-6 block hidden sm:block">
      <div className="relative w-full">
            {/* LEFT ARROW */}

            <button onClick={() => scroll("left")} className="absolute -left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"><path d="m15 18-6-6 6-6"></path></svg>
            </button>

            {/* SCROLL CONTAINER */}
            <div
              ref={sliderRef}
              className="flex gap-4 p-4 overflow-x-auto scroll-smooth touch-pan-x"
            >
            
            {experts.map((expert, index) => (
                <div key={expert.id || index} className="group w-48 sm:w-64 md:w-72 lg:w-80 flex-shrink-0">
                  <div className="relative bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500">
                    <div className="relative h-60 sm:h-80 md:h-96 lg:h-[420px] overflow-hidden">
                      <img
                        alt={expert.name}
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-700 group-hover:scale-105"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          left: 0,
                          top: 0,
                          right: 0,
                          bottom: 0,
                          color: "transparent"
                        }}
                        src={
                          expert.profile_image
                            ? `${API_BASE}${expert.profile_image}`
                            : "/assets/images/no-image.png"
                        }
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                        {/*<p className="text-primary/90 text-xs md:text-sm font-medium mb-1 md:mb-2">
                          Heritage &amp; Culture
                        </p>*/}
                        <h3 className="text-white font-bold text-base md:text-xl lg:text-2xl leading-tight mb-1 md:mb-2">
                          {expert.name}
                        </h3>
                        <div className="flex items-center gap-1.5 md:gap-2 text-white/70 text-xs md:text-sm">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-map-pin h-3 w-3 md:h-4 md:w-4"
                          >
                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                            <circle cx={12} cy={10} r={3} />
                          </svg>
                          <span>{expert.city}</span>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 md:p-4 bg-white">
                      <div className="flex items-center justify-between">
                        {/*<span className="text-xs md:text-sm text-slate-500">
                          32 trips hosted
                        </span>*/}
                        <span className="text-xs md:text-sm font-medium text-primary">
                          View Profile
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            ))}

            </div>

            {/* RIGHT ARROW */}
            <button onClick={() => scroll("right")} className="absolute -right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"><path d="m9 18 6-6-6-6"></path></svg>
            </button>
          </div>
      </div>



      {/* Mobile */}
      <div className=" pb-4 md:pb-6 -mb-4 md:-mb-6 block sm:hidden">
        <div className="flex gap-3 md:gap-6 px-4 md:px-6 scrollbar-custom">
        
        {experts.map((expert, index) => (
          <div key={expert.id || index} className="group w-48 sm:w-64 md:w-72 lg:w-80 flex-shrink-0">
            <div className="relative bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500">
              <div className="relative h-60 sm:h-80 md:h-96 lg:h-[420px] overflow-hidden">
                <img
                  alt={expert.name}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0
                  }}
                  src={
                        expert.profile_image
                          ? `${API_BASE}${expert.profile_image}`
                          : "/assets/images/no-image.png"
                      }
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                  {/*<p className="text-primary/90 text-xs md:text-sm font-medium mb-1 md:mb-2">
                    High Altitude Expert
                  </p>*/}
                  <h3 className="text-white font-bold text-base md:text-xl lg:text-2xl leading-tight mb-1 md:mb-2">
                    {expert.name}
                  </h3>
                  <div className="flex items-center gap-1.5 md:gap-2 text-white/70 text-xs md:text-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3 w-3 md:h-4 md:w-4"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span>{expert.city}</span>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4 bg-white">
                <div className="flex items-center justify-between">
                  {/*<span className="text-xs md:text-sm text-slate-500">
                    47 trips hosted
                  </span>*/}
                  <span className="text-xs md:text-sm font-medium text-primary">
                    View Profile
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}

        </div>
      </div>
      <div className="container mx-auto px-4 md:px-6 mt-8 md:mt-12 text-center">
        <p className="text-slate-600 text-xs md:text-base mb-3 md:mb-4">
          Are you a passionate local with stories to share?
        </p>
        <a
          className="inline-flex items-center gap-2 bg-slate-900 text-white px-4 md:px-6 py-2.5 md:py-3 rounded-full text-sm md:text-base font-medium hover:bg-slate-800 transition-colors"
          href="/become-expert"
        >
          Become a Travel Expert
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-arrow-right h-3.5 w-3.5 md:h-4 md:w-4"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    

    </section>
);

};

export default Localocalexpertlist;
